export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7107.0a214d20.jpg";